import { ApiErrorCode, withApiErrorHandler } from '@/modules/common/api/errors';
import { mapUserGroupsFromResponse } from '@/modules/common/mappers/user-group.mapper';
import { UserGroupResponse } from '@/modules/common/types/dto/user-group-response';
import { UserGroup } from '@/modules/common/types/user-group';
import { axiosInstance } from '@/utils/axios';

/**
 * Retrieves list of user groups available in the organization.
 * Used for team member invitation, settings, and access management.
 * GET /api/team/user-groups
 */
export const getUserGroups = async (): Promise<UserGroup[]> => {
  const endpoint = '/api/team/user-groups';

  const response = await withApiErrorHandler(endpoint, ApiErrorCode.USER_GROUPS_LOAD_FAILED, () =>
    axiosInstance.get<{
      data: UserGroupResponse[];
      error?: { status: number; message: string; code: string };
    }>(endpoint)
  );

  return mapUserGroupsFromResponse(response);
};
